import { WebsocketStore } from '../../stores/websocketStore/websocketStore';
import { TradePlanData } from './tradePlanData';

type Args = {
  tradePlanDataInstance: TradePlanData;
  keysToOverWrite: Partial<TradePlanData>;
  websocketStore: WebsocketStore | null;
};

export default function createTradePlanCopy({
  tradePlanDataInstance,
  keysToOverWrite,
  websocketStore,
}: Args) {
  const existingJson = tradePlanDataInstance.returnJson();
  const newTradePlanInstance = new TradePlanData(websocketStore);
  newTradePlanInstance.setFormToTemplate(existingJson);
  newTradePlanInstance.setFormToTemplate(keysToOverWrite);
  // console.log(`evaluateQuotes in createTradePlanCopy is ${newTradePlanInstance.evaluateQuotes}`)
  return newTradePlanInstance;
}
